import { httpInstance } from './http'
import { selectedBankId } from '@/stores/banks'
import {
  shopAnalyticsCheckoutProgress,
  shopAnalyticsPurchase,
} from '../../../../../Greativ/shop/analytics'
import {
  products,
  productsTotalVat,
  productsTotalVatPrice,
} from '@/stores/product'
import { bonusCode } from '@/stores/bonusCode'
import { transportTotalVatPrice, transportTotalVat } from '@/stores/transport'
import { basketId } from '@/stores/basket'

export async function checkout() {
  try {
    const data = {}
    if (selectedBankId.value === 'invoice') {
      data['invoice'] = true
    } else {
      data['bank'] = selectedBankId.value
    }
    const {
      data: { success, redirect, message },
    } = await httpInstance.post('checkout', data)

    shopAnalyticsCheckoutProgress({
      items: products.value,
      bonusCode: bonusCode.value,
    })

    if (success) {
      if (redirect) {
        window.location.href = redirect
        return {
          redirecting: true,
          success,
          message,
        }
      } else {
        shopAnalyticsPurchase({
          basketId: basketId.value,
          totalPrice:
            productsTotalVatPrice.value + transportTotalVatPrice.value,
          totalVat: productsTotalVat.value + transportTotalVat.value,
          transportPrice: transportTotalVatPrice,
          items: products.value,
        })
        return {
          redirecting: false,
          success,
          message,
        }
      }
    }
    return {
      redirecting: false,
      success,
      message,
    }
  } catch (error) {
    console.error(error)
  }

  return {
    success: false,
  }
}
